import script from "./HowToTrainList.vue?vue&type=script&setup=true&lang=js"
export * from "./HowToTrainList.vue?vue&type=script&setup=true&lang=js"

import "./HowToTrainList.vue?vue&type=style&index=0&id=693ba4eb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-693ba4eb"]])

export default __exports__